import { defineStore } from 'pinia';
import { useSessionStore } from '@/store/session';
import { useAppStore } from '@/store/app';

export const usePetTransportStore = defineStore('pet_transport', () => {
    const sessionStore = useSessionStore();
    const appStore = useAppStore();

    const exists = computed(() => !!getItem.value);

    const getItem = computed(() => {
        return sessionStore?.order?.items?.find((item) => item.productable_type === 'pet_transport') ?? null;
    });

    const getProduct = computed(() => {
        return getItem.value?.product ?? null;
    });

    const isCallbackRequested = computed(() => sessionStore.order?.pet_transport_callback_requested);

    const canRemove = computed(() => getItem.value?.status === 'UNCONFIRMED');

    const isConfirmed = computed(() => getItem.value?.status === 'CONFIRMED');

    const canIndividuallyBook = computed(() => {
        return getProduct.value?.status === 'QUOTED';
    });

    const getPaidButtonCopy = computed(() => {
        if (isConfirmed.value && ['READY', 'COMPLETED'].includes(getProduct.value?.status)) {
            return 'Paid';
        }
        if (isConfirmed.value) {
            return 'Pending';
        }

        return null;
    });

    const hasFailedConfirmationPayment = computed(() => {
        if (getProduct.value?.confirmation_payment?.status == 'FAILED') {
            return true;
        }
        return false;
    });

    const isDisabled = computed(() => !appStore.pet_transport_enabled);

    async function remove(id) {
        const petTransportId = id ?? getProduct.value?.id;
        if (!petTransportId) return;
        await window.axios.delete(`/customers/book/orders/${sessionStore.getOrderId}/pet-transport/${petTransportId}`);
        await sessionStore.retrieve();
    }

    return {
        exists,
        getItem,
        getProduct,
        isCallbackRequested,
        canRemove,
        isConfirmed,
        canIndividuallyBook,
        getPaidButtonCopy,
        hasFailedConfirmationPayment,
        isDisabled,
        remove,
    };
});
